module.exports = __webpack_public_path__ + "img/heart-outline-secondary.4993684f.svg";